import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import RouteOverviewTreePopup, { typeOfRouteOverviewTreeDialog } from '@Pages/RetroSynthesis/RouteTree/components/RouteOverviewTreePopup';
import Button from '@Components/Button';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import { isPredictedRoute } from '@Pages/RetroSynthesis/ProjectRoute/selectors';
import { getProjectsInfoMap } from '@Pages/RetroSynthesis/RsBreadcrumbs/selector';
import { onRouteViewClick } from '@Pages/RetroSynthesis/ProjectRoutes/analytics';
import { getProjectsRoutesDataResponseList } from '@Pages/RetroSynthesis/ProjectRoutes/selectors';

import './RouteOverviewTreePopupContainer.scss';
/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
export const openRouteOverviewTreeDialog = ({ treeList, routeName, projectId, routeId }) => {
  return updateDialog({
    id: typeOfRouteOverviewTreeDialog,
    typeOfRouteOverviewTreeDialog,
    dialogType: typeOfRouteOverviewTreeDialog,
    treeList,
    routeName,
    projectId,
    routeId,
  });
};
export function RouteOverviewTreePopupContainer({
  selfClose,
  treeList,
  routeName,
  projectId,
  routeId,
  isPredictedRoute,
  projectsInfo,
  routes,
}) {
  const history = useHistory();

  const navigateToRouteTreeView = () => {
    history.push(RsRoute.getProjectRouteTreeViewLink(projectId, routeId));
    const projectInfo = (projectsInfo && projectsInfo[projectId]) || {};
    onRouteViewClick(
      projectId,
      routes.filter((r) => routeId === r.id),
      projectInfo
    );
    selfClose();
  };

  return (
    <RouteOverviewTreePopup
      treeList={treeList}
      selfClose={selfClose}
      routeName={routeName}
      className="route-overview-tree-popup-container"
      footerClassName="route-overview-tree-popup-container__footer"
      footer={
        <Button
          buttonConfig={{ type: 'primary', size: 'sm', label: 'View in Tree view', e2eName: 'view-in-tree-view' }}
          iconConfig={{ name: 'chevron-right' }}
          onClick={navigateToRouteTreeView}
        />
      }
      isPredictedRoute={isPredictedRoute}
    />
  );
}

const mapStateToProps = (state) => ({
  isPredictedRoute: isPredictedRoute(state),
  projectsInfo: getProjectsInfoMap(state),
  routes: getProjectsRoutesDataResponseList(state),
});
export default connect(mapStateToProps, null)(RouteOverviewTreePopupContainer);
